import { memo, useRef, useState } from "react";

import locale from "plotly.js-locales/fr";
import Plotly from "react-plotly.js";

import "./Plot.css";

const Plot = memo(
  ({
    plotData,
    from,
    to,
    yaxisTitle,
    setHoveredFeatureId,
    selectedFeature,
    setSelectedFeature,
    isFeatureSelected,
    isLoading,
    hasFetchFailed,
  }) => {
    const isFirstTime = useRef(true);

    const makeAnnotation = ({ x, y, color }) => {
      return {
        x,
        y,
        xref: "x",
        yref: "y",
        showarrow: true,
        arrowsize: 0.5,
        arrowhead: 2,
        arrowcolor: "gray",
        ax: 0,
        ay: -40,
        bgcolor: "rgba(255, 255, 255, 0.9)",
        font: { size: 12 },
        bordercolor: color,
        borderwidth: 3,
        borderpad: 4,
        text: "Sélection",
        hovertext: "Cliquez ici pour annuler la sélection",
      };
    };

    const [annotations, setAnnotations] = useState(
      selectedFeature
        ? [
            makeAnnotation({
              x: selectedFeature.x,
              y: selectedFeature.y,
              color: selectedFeature.color,
            }),
          ]
        : [],
    );

    const handleHover = (data) => {
      if (data.points.length === 1) {
        setHoveredFeatureId(data.points[0].customdata);
      }
    };

    const handleUnhover = () => {
      setHoveredFeatureId("");
    };

    const handleClick = (data) => {
      if (data.points.length === 1) {
        const point = data.points[0];
        setSelectedFeature({
          id: point.customdata,
          x: point.x,
          y: point.y,
          color: point.fullData.marker.color,
        });
        // doc: https://plotly.com/javascript/reference/layout/annotations/
        setAnnotations([
          makeAnnotation({
            x: point.x,
            y: point.y,
            color: point.fullData.marker.color,
          }),
        ]);
      }
    };

    const handleClickAnnotation = () => {
      setSelectedFeature({ id: null });
      setAnnotations([]);
    };

    const handlePurge = () => {
      if (!isLoading && !isFirstTime.current) {
        setAnnotations([]);
      }
      isFirstTime.current = false;
    };

    return (
      <div className="plot">
        {!isFeatureSelected ? (
          <div style={{ fontSize: 30, marginTop: 80 }}>
            Veuillez séléctionner un tronçon ou une alerte sur la carte...
          </div>
        ) : isLoading ? (
          <div style={{ fontSize: 30, marginTop: 80 }}>
            Chargement des données en cours...
          </div>
        ) : hasFetchFailed ? (
          <div style={{ fontSize: 30, marginTop: 80 }}>
            Le chargement des données a échoué :-(
          </div>
        ) : plotData.length > 0 ? (
          <Plotly
            data={plotData}
            useResizeHandler={true}
            style={{ width: "100%", height: "100%" }}
            layout={{
              autosize: true,
              uirevision: true,
              margin: {
                l: 60,
                r: 100,
                b: 5,
                t: 20,
                pad: 0,
              },
              xaxis: {
                // title: "t",
                range: [`${from}`, `${to}`],
                tickformat: "%H:%M\n%a %d-%m-%y",
                rangeslider: {
                  range: [`${from}`, `${to}`],
                },
                type: "date",
              },
              yaxis: {
                title: yaxisTitle,
                fixedrange: false,
                zeroline: false,
              },
              legend: {
                itemsizing: "trace",
              },
              annotations: annotations,
            }}
            config={{
              locales: { fr: locale },
              locale: "fr",
              responsive: true,
            }}
            onHover={handleHover}
            onUnhover={handleUnhover}
            onClick={handleClick}
            onClickAnnotation={handleClickAnnotation}
            onPurge={handlePurge}
          />
        ) : (
          <div style={{ fontSize: 30, marginTop: 80 }}>
            Aucune donnée n'est disponible pour cette sélection.
          </div>
        )}
      </div>
    );
  },
);

export default Plot;
